import styles from "./styles.module.scss";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { CheckboxGroupProps } from "./types";
import { TableContext } from "../../../contexts/table/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
//UI
import Space from "antd/lib/space";
import Button from "antd/lib/button";
import Checkbox from "antd/lib/checkbox";
import type { CheckboxValueType } from "antd/es/checkbox/Group";

const CheckboxGroup = Checkbox.Group;

// Компонент обробки кліку на чекбокс

export default function CheckboxGroupComponent(props: CheckboxGroupProps) {
  const location = useLocation();
  const { onBoxStrChange, setButtonStr, boxStr, setCheckboxStr, setVisibleColumn } =
    useContext(TableContext);
  const { intl } = useContext(TranslationContext);

  const [buttonLetterStr, setButtonLetterStr] = useState<string | undefined>("");
  // const [buttonStr, setButtonStr] = useState("");
  // const [checkboxStr, setCheckboxStr] = useState("");
  const [checkedList, setCheckedList] = useState<CheckboxValueType[]>([]);
  const isTypesOfDocuments =
    (props.url || location.pathname) === "/directories/types-of-documents";
  const plainOptions = isTypesOfDocuments
    ? [intl("with-deleted")]
    : [
        intl("employees"),
        intl("contact-persons-of-other-enterprises"),
        intl("head"),
        intl("right-control"),
        intl("with-the-dismissed"),
      ];

  const letters = [
    "А",
    "Б",
    "В",
    "Г",
    "Д",
    "Е",
    "Є",
    "Ж",
    "З",
    "И",
    "І",
    "Ї",
    "Й",
    "К",
    "Л",
    "М",
    "Н",
    "О",
    "П",
    "Р",
    "С",
    "Т",
    "У",
    "Ф",
    "Х",
    "Ц",
    "Ч",
    "Ш",
    "Щ",
    "Ю",
    "Я",
  ];

  useEffect(() => {
    if (isTypesOfDocuments && checkedList.length === 0) {
      onCheckboxGroupChange([]);
    }
  }, []);
  
  // useEffect(() => {
  //   setCheckboxStr("and isnull(eta_TypeDoc.del,0)=0");
  // }, []);


  const onButtonClick = (letter: string) => {
    console.log("CLICK ", props?.url, props?.formName);
    
    if(props?.url && checkedList && checkedList.length > 0 &&
    !boxStr?.find((item) => item.url === props?.url)?.checkboxStr) onCheckboxGroupChange(checkedList);

    const newButtonStr = `and contact_person like '${letter}%'`;
    setButtonLetterStr(letter);
    setButtonStr(newButtonStr);
    // props?.url && props?.formName && onBoxStrChange({url: props?.url, formName:"main", buttonStr: newButtonStr});
    props?.url && onBoxStrChange({url: props?.url, formName:props?.formName ? props?.formName : "main", buttonStr: newButtonStr});

  };

  const onCheckboxGroupChange = (list: CheckboxValueType[]) => {
    // console.log("list CHECKBOX ", list);
    let newList = [...list];
    let str = "";
    if (
      newList.includes(intl("employees")) &&
      newList.includes(intl("contact-persons-of-other-enterprises"))
    ) {
      newList = newList.filter(
        (item) =>
          checkedList.includes(intl("employees")) && item !== intl("employees") ||
          checkedList.includes(intl("contact-persons-of-other-enterprises")) && item !== intl("contact-persons-of-other-enterprises")
      );
    } 
    
    if (newList.includes(intl("employees"))) {
      str += "and typerec = 2";
    } else if (newList.includes(intl("contact-persons-of-other-enterprises"))) {
      str += " and typerec = 1";
    }
    if (newList.includes(intl("head"))) {
      str += " and is_kerivnik = 1";
    }
    if (newList.includes(intl("right-control"))) {
      str += " and is_control = 1";
    }
    if (newList.includes(intl("with-the-dismissed"))) {
      str += " and isnull(is_uvolen,0) in (1,0)";
      // str += " and isnull(is_uvolen,0)=1";

    } /* else {
      str += " and isnull(is_uvolen,0)=0";
    } */
    /* if (isTypesOfDocuments) { */
    if (isTypesOfDocuments) {
      if (newList.includes(intl("with-deleted"))) {
        str = "";
        setVisibleColumn(true);
      } else {
        str = "and isnull(eta_TypeDoc.del,0)=0";
        setVisibleColumn(false);
      }
    }
    /* } */
    // console.log("NEWlist CHECKBOX FULL", newList);

    setCheckedList(newList);
    setCheckboxStr(str.trim());
    // props?.url && props?.formName && onBoxStrChange({url: props?.url, formName:props?.formName, checkboxStr: str});
    // if (props?.formName && props?.url && buttonLetterStr && !boxStr?.find((item) => item.url === props?.url)?.buttonStr) {
    //   const newButtonStr = `and contact_person like '${buttonLetterStr}%'`;
    //   onBoxStrChange({url: props?.url, formName:props?.formName, buttonStr: newButtonStr});
    // }

        props?.url && onBoxStrChange({url: props?.url, formName:props?.formName ? props?.formName : "main", checkboxStr: str});
    if (props?.formName && props?.url && buttonLetterStr && !boxStr?.find((item) => item.url === props?.url)?.buttonStr) {
      const newButtonStr = `and contact_person like '${buttonLetterStr}%'`;
      onBoxStrChange({url: props?.url, formName:props?.formName ? props?.formName : "main", buttonStr: newButtonStr});
    }
  };

  return (
    <div className="LETTERS==STYLE==BLOCK">
      {!isTypesOfDocuments && (
        <div className={styles["space"]} style={{ gap: 3 }}>
          {letters.map((letter) => (
            <Button
              className={`${styles.letters} ${letter === buttonLetterStr ? styles["letters-active"] : ""}`}
              key={letter}
              onClick={() => onButtonClick(letter)}
            >
              {letter}
            </Button>
          ))}
        </div>
      )}
      <CheckboxGroup
        className={styles["checkbox-group"]}
        options={plainOptions}
        value={checkedList}
        onChange={onCheckboxGroupChange}
      />
    </div>
  );
}
